/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/order */

import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import Radio from "@mui/material/Radio";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./BudgetExceededProjectMaster.module.css";
import { CustomTab, Button } from "../../atomicComponents";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { withAllowedOperationsProvider } from "../../hocs";
import {
    CustomFormGroup,
} from "../../components/FormComponents";

// eslint-disable-next-line import/order
import {
    Grid,
} from "@material-ui/core";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import {
    RESOURCE_TYPE,
    MESSAGE_TYPE,
    headers,keys,tableHeaderLabel,headerKeyMap,expectedHeaders
} from "../../constants";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import { downloadExcel, downloadFileFromUrl, sanitizeNumeric } from "../../utils/utils";
import Truckloading from '../../components/CvLoader/Cvloader';
import apiService from "../../apis/apiService";
import { useDispatch,useSelector } from "react-redux";



const BudgetExceededProjectMaster = () => {
     const auth = useSelector((state) => state.auth); // useSelector
    const history = useHistory();
    const [file, setFile] = useState('')
    const { showPopup } = usePopupManager();
    const [isDataView, setIsDataView] = useState(false)
    const [loadingTruck, setLoadingTruck] = useState(false)
    const [tableData,setTableData] = useState([])
    const [selectredio,setSelectedRadio] = useState('');
    // const [flag,setFlag] = useState('')
    const inputRef = useRef(null)

    const redirectToApplicationLandingPage = () => {
        history.push("/home");
    };
    const dispatch = useDispatch()

    const uploadFile = async() =>{
        const payload = new FormData()
            payload.append('file',file)
            payload.append('pers_no',sanitizeNumeric(auth.personNumber))
        try {
            setLoadingTruck(true)
            const data = await apiService.uploadBudgetExceededData(payload,dispatch);         
            if(data.data.msg === 'Success'){
                showPopup({
                    type: MESSAGE_TYPE.SUCCESS,
                    contextText: MESSAGE_TYPE.SUCCESS,
                    info: data.data.data,
                })
                setFile('')
                if (inputRef.current) {
                    inputRef.current.value = '';
                  }
            } else{
                showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: data.data.data ?? 'Please check the file format',
                })
                setFile('')
            }
        } catch (error) {
                const errorMsg =
                error?.response?.data?.data ||  error?.response?.data?.msg || 
                error?.message || 'Something went wrong!'

            showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: errorMsg,
            });
            console.error(error)
            setLoadingTruck(false)
        } finally {
            setLoadingTruck(false)
        }
    }

    const getBudgetExceededData = async(isFlag) =>{
        setLoadingTruck(true)
        try {

            const payload = {
                'flag':isFlag
            }
            const response = await apiService.getBudgetExceededData(payload,dispatch)         
            if(response.data.msg === 'Success'){            
                setTableData(response.data.data)
                setFile(null)
            }
        } catch (error) {
            console.error(error)
        } finally{
            setLoadingTruck(false)
        }
    }
    const handleFileChange = (e, onData) => {
        const fileName = e.target.files[0];       
        if (!fileName) return;

        // Validate file name
        if (!fileName.name.includes('Budget_Exceeded_Projects')) {
            showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Please select correct template",
            });
            return;
        }

        const reader = new FileReader();
        reader.onload = (evt) => {
            const arrayBuffer = evt.target.result;
            const workbook = XLSX.read(arrayBuffer, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(worksheet, { defval: "", header: 1 });
            const headerss = data[0] || [];
            const isHeaderValid =
            headerss.length === expectedHeaders.length &&
            headerss.every((header, index) => header === expectedHeaders[index]);
            if (isHeaderValid) {
                setFile(fileName);
            }
            if (!isHeaderValid) {
                showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "Please select a valid file format",
                });
                return;
            }
            const rowData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

            if (onData) onData(rowData);

        };

        reader.readAsArrayBuffer(fileName);
    };
   
    
    const filteredHeaders = tableHeaderLabel.filter((header) =>
        (tableData ?? []).some(
          (row) => Object.prototype.hasOwnProperty.call(row, headerKeyMap[header])
        )
      );
      const filteredTableData = (tableData ?? []).map((row) => {
        const filteredRow = {};
      
        filteredHeaders.forEach((header) => {
          const key = headerKeyMap[header];
          filteredRow[header] = row[key] ?? "";
        });
      
        return filteredRow;
      });

    const handleDownload = async () => {
        try {
            const payload = {
                'path': 'Budget_Exceeded_Projects.xlsx'
            }
            const response = await apiService.downloadBudgetExcededTemplate(payload,dispatch)

            if (response.data.url) {
                
                downloadFileFromUrl(response.data.url,'Budget_Exceeded_Projects.xlsx');
            }
            else {
                setLoadingTruck(false)
                showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: "failed to download",
                });

            }
        }
        catch (error) {
            console.log('Error', error)
            setLoadingTruck(false)
            showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "failed to download",
            });
        }

    };
const handleRadioSelectionChange = (event) =>{
    const isActive = event.target.value;
    // setFlag(isActive);
    setSelectedRadio(isActive)
    if(isActive){
        getBudgetExceededData(isActive)
    }
    
}

    const handleCancel = () => {
        setFile(null);   

    };
    const renderOther1 = () => (
        <div
            className={styles.formGroup}
        >
            <Grid
                container
                spacing={2}
                style={{ marginTop: "2px" }}
                columns={12}
                className={styles.myGrid}
            >

                <Grid item md={5} lg={5} sm={12}>
                    <div className={styles.rowDiv}>
                        <div className={clsx(styles.lableDiv1)}>
                            <div style={{ display: "flex", alignContent: "center", cursor: 'pointer' }}>
                                <label>Download Template</label>
                                <DownloadIcon
                                    color="primary"
                                    onClick={handleDownload}
                                    style={{ marginLeft: "10px" }}
                                />
                            </div>
                        </div>

                    </div>

                </Grid>

            </Grid>
        </div>
    );
    const renderOther = () => (
        <div
            className={styles.formGroup}
        >
            <Grid
                container
                spacing={3}
                columns={12}
                className={styles.myGrid}
            >
                <Grid item md={4} lg={4} sm={12}>
                    <div className={styles.rowDiv}>
                        <div className={styles.formDiv} style={{ paddingTop: "10px", cursor: 'pointer' }}>
                            <input
                               ref={inputRef}
                                type="file"
                                onChange={(e) => {
                                    handleFileChange(e);
                                    setFile(e)
                                }}
                                id="upload-file"
                                data-testid={`upload-file-${document.id}`}
                                className={styles.contentfile}
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            />
                        </div>
                        <div className={styles.rowDiv}>
                            <div className={styles.formDiv} style={{ justifyContent: "start", gap: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Button
                                        className={clsx(styles.actionButton)}
                                        variant="primary"                                 
                                        disabled={!file}
                                        data-testid="confirm-action"
                                        style={{ marginRight: "5px" }}
                                        onClick={() => uploadFile()}
                                    >
                                        Upload
                                    </Button>

                                    <Button
                                        className={clsx(styles.actionButton, styles.resetButton)}
                                        variant="tertiary"
                                        onClick={handleCancel}
                                        style={{ marginRight: "5px" }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    );

    const renderReport = () => (
        <div className={styles.formGroup}>
            <Grid
                container
                spacing={3}
                columns={12}
                className={styles.myGrid}
            >
                <Grid item md={4} lg={4} sm={12} style={{ display: 'flex', justifyContent: 'end' }}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"                       
                        style={{                          
                            marginRight: "11px",
                        }}
                        value={selectredio == null ? null : selectredio}
                        onChange={handleRadioSelectionChange}
                        defaultValue="Active"                   
                    >
                        <>
                            <FormControlLabel
                                value="Active"
                                name="Active"
                                control={<Radio size="small" />}
                                label="Active"
                                className={styles.radiobtn}
                            />
                            <FormControlLabel
                                value="All"
                                name="All"
                                control={<Radio size="small" />}
                                label="All"
                                className={styles.radiobtn}
                            />
                        </>

                    </RadioGroup>
                </Grid>
                <Grid item md={4} lg={4} sm={12}>
                    <div className={styles.rowDiv}>
                        <div className={styles.formDiv} style={{ justifyContent: "center", gap: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    className={clsx(styles.actionButton)}
                                    variant="contained"
                                    data-testid="confirm-action"
                                    style={{
                                        marginRight: "5px",
                                        backgroundColor: selectredio?"orange":"#d8d8d8",
                                        color: selectredio ? "#fff" : "rgba(0,0,0,0.26)",
                                    }}
                                    disabled = {!selectredio}
                                    onClick={() => {
                                        setIsDataView(true);                             
                                    }}
                                >
                                    View
                                </Button>
                                <Button
                                    className={clsx(styles.actionButton)}
                                    variant="primary"                                  
                                    data-testid="confirm-action"
                                    style={{ marginRight: "5px" }}
                                    disabled = {!selectredio}
                                    onClick={() => {
                                        downloadExcel(headers, keys, tableData)
                                    }}
                                >
                                    Download
                                </Button>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ marginTop: "10px", justifyContent: 'center', display: 'flex' }} columns={12}>

                <Grid item md={10} lg={10} xs={10} sm={10}>
                    {
                        isDataView && (
                            <div className={styles.formDiv}>
                                <TableSimple
                                    tableColumnData={filteredTableData ?? []}
                                    tableHeaderLabel={filteredHeaders}
                                    TableRowHederAling="center"
                                    size="small"
                                    headerColor="#E6F2FF"
                                />
                            </div>
                        )
                    }

                </Grid>
            </Grid>
        </div>
    );

    return (
        <>
            <div className={styles.container} style={{ boxSizing: "border-box" }}>
                <div className={styles.backButtonLastRefreshedDateWrapper} style={{ display: "none" }}>

                    <BackButton
                        action="Home"
                        handleClick={redirectToApplicationLandingPage}
                    />
                </div>
                <div className={styles.processHeader}>
                    <div className={styles.CustomTabClass}>
                        <CustomTab title="Project Linkage" withOutCount isSelected />
                    </div>
                    <div className={styles.processTopbar}>
                        <UserInfoPanel
                            userInfo={[
                                {
                                    Name: "Aditya Mathur",
                                    "SAP ID": 122355,
                                    "BC No": "122355",
                                    LOC: "Engineering and Research Center",
                                },
                            ]}
                        />
                    </div>
                </div>

                <div
                    className={clsx(
                        styles.scrollContainer,
                        styles.scrollBar,
                        styles.formContainer
                    )}
                >
                    <CustomFormGroup header="Budget Exceeded Project Master" body="" />
                    {renderOther1()}
                    {renderOther()}
                    <hr />
                    {renderReport()}
                    {loadingTruck ? (
                        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "40px" }}>
                            <Truckloading />
                        </div>) : (<></>)
                    }
                </div>


            </div>
        </>
    )
}
export default withAllowedOperationsProvider(
    BudgetExceededProjectMaster,
    RESOURCE_TYPE.PROJECT
);
